import { render, staticRenderFns } from "./HomeTabs.vue?vue&type=template&id=067638fe&"
import script from "./HomeTabs.vue?vue&type=script&lang=js&"
export * from "./HomeTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports